import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap, finalize } from 'rxjs';
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
} from 'src/app/shared/constants/general.constants';
import { AuthService, HelpersService } from '@evento-ng/libs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  public loginForm: UntypedFormGroup;

  constructor(
    public formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private helpers: HelpersService,
    private route: ActivatedRoute,
    public spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initLoginForm();
  }

  private initLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      mobile: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  login(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.spinner.show();
    const { mobile, password } = this.loginForm.value;

    this.authService
      .signIn(mobile, password)
      .pipe(
        tap((response: any) => {
          if (response?.access_token) {
            this.helpers.setItemToLocalStorage(
              ACCESS_TOKEN,
              response.access_token
            );
            if (response.refresh_token) {
              this.helpers.setItemToLocalStorage(
                REFRESH_TOKEN,
                response.refresh_token
              );
            }
            this.authService.fetchUser();
          }
        }),
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe({
        next: () => {
          this.router.navigateByUrl('/home');
        },
        error: (error) => {
          console.error('Login failed:', error);
        },
      });
  }
}
